var DEFAULT_MAX_ATTEMPTS = 3;
var BASE_RETRY_DELAY_MS = 600;

function stableHash(value) {
  var str = String(value || '');
  var hash = 0;
  for (var i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

function appendParams(url, params) {
  var query = new URLSearchParams();
  Object.keys(params || {}).forEach(function(key) {
    var value = params[key];
    if (Array.isArray(value)) {
      value.forEach(function(item) {
        query.append(key + '[]', item);
      });
    } else if (value != null) {
      query.append(key, value);
    }
  });

  var queryString = query.toString();
  if (!queryString) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + queryString;
}

function payloadDigest(params) {
  var summary = {};
  Object.keys(params || {}).forEach(function(key) {
    var value = params[key];
    if (key === 'deck' || key === 'deckContents') {
      var text = String(value || '');
      summary[key] = {
        length: text.length,
        hash: stableHash(text)
      };
    } else {
      summary[key] = value;
    }
  });
  return summary;
}

function sanitizeUrl(fullUrl) {
  try {
    var parsed = new URL(fullUrl, window.location.origin);
    ['deck', 'deckContents'].forEach(function(key) {
      if (parsed.searchParams.has(key)) {
        var value = parsed.searchParams.get(key) || '';
        parsed.searchParams.set(key, '[length:' + value.length + ',hash:' + stableHash(value) + ']');
      }
    });
    return parsed.pathname + parsed.search;
  } catch (_error) {
    return String(fullUrl || '').replace(/(deck(?:Contents)?=)[^&]+/g, function(match, prefix) {
      return prefix + '[redacted]';
    });
  }
}

function responseContentType(response) {
  return (response && response.headers && response.headers.get('content-type') || '').toLowerCase();
}

function isJavaScriptResponse(response) {
  return response && response.ok && responseContentType(response).indexOf('javascript') !== -1;
}

function isTransientFailure(error) {
  if (error && error.isNetworkError) return true;
  var status = error && error.status;
  return status === 429 || (status >= 500 && status <= 599);
}

function isBlockedOrAbortedScriptResponse(error, job) {
  var status = error && error.status;
  var endpoint = job && job.endpoint;
  var isNoisyWidgetEndpoint = endpoint === '/widgets/deck/js' || endpoint === '/widgets/price_compact/js';
  return isNoisyWidgetEndpoint && (status === 403 || status === 499);
}

function targetForDeckJob(job) {
  if (job.failureTarget) return job.failureTarget;
  var params = job.params || {};
  if (params.selector) {
    var paneId = params.selector.charAt(0) === '#' ? params.selector.slice(1) : params.selector;
    return paneId ? document.getElementById(paneId) : null;
  }
  if (params.domId) return document.getElementById(params.domId);
  if (job.domId) return document.getElementById(job.domId);
  if (job.deckId) return document.querySelector(".widget-deck-placeholder[data-id='" + job.deckId + "']");
  return null;
}

function renderDeckFailure(job, error, queue) {
  var target = targetForDeckJob(job);
  if (!target) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'deck-widget-load-failure alert alert-warning py-2 px-3 my-2';
  wrapper.setAttribute('role', 'alert');

  var message = document.createElement('span');
  message.textContent = 'Deck content could not load.';
  wrapper.appendChild(message);

  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'btn btn-sm btn-outline-secondary ms-2 deck-widget-load-retry';
  button.textContent = 'Retry';
  button.addEventListener('click', function() {
    wrapper.remove();
    queue.enqueue(job.url, job.params, Object.assign({}, job.options, {
      priority: 'high',
      force: true
    }));
  });
  wrapper.appendChild(button);

  target.innerHTML = '';
  target.appendChild(wrapper);
}

function deckWidgetMetadata(job) {
  var params = job.params || {};
  return {
    payload: payloadDigest(params),
    domId: job.domId || params.domId || null,
    deckId: job.deckId || params.deckId || params.id || null
  };
}

function notifyWarning(job, error, queueDepth, options) {
  if (!window.Bugsnag || typeof window.Bugsnag.notify !== 'function') {
    console.error(error);
    return;
  }

  var userIdMeta = document.querySelector('meta[name="bugsnag-user-id"]');
  var metadata = {
    endpoint: job.endpoint,
    sanitizedUrl: sanitizeUrl(job.requestUrl || job.url),
    status: error.status || null,
    contentType: error.contentType || null,
    cfRay: error.cfRay || null,
    attemptCount: job.attempt,
    queueDepth: queueDepth,
    userId: userIdMeta ? userIdMeta.content : null
  };
  if (options && typeof options.metadataForJob === 'function') {
    Object.assign(metadata, options.metadataForJob(job, error) || {});
  }
  window.Bugsnag.notify(error, function(event) {
    event.severity = 'warning';
    event.addMetadata((options && options.metadataNamespace) || 'scriptRequestQueue', metadata);
  });
}

function createScriptRequestQueue(options) {
  var queue = [];
  var activeKeys = {};
  var running = false;
  var timer = null;
  var fetchImpl = options && options.fetchImpl;
  var setTimeoutImpl = options && options.setTimeoutImpl || setTimeout;
  var clearTimeoutImpl = options && options.clearTimeoutImpl || clearTimeout;
  var maxAttempts = options && options.maxAttempts || DEFAULT_MAX_ATTEMPTS;
  var retryDelayMs = options && options.retryDelayMs || BASE_RETRY_DELAY_MS;

  function keyFor(url, params) {
    return appendParams(url, params);
  }

  function schedule(delay) {
    if (timer) clearTimeoutImpl(timer);
    timer = setTimeoutImpl(drain, delay || 0);
  }

  function execute(job) {
    var requestUrl = appendParams(job.url, job.params);
    job.requestUrl = requestUrl;
    job.attempt += 1;

    return (fetchImpl || fetch)(requestUrl, {
      headers: {
        'Accept': 'text/javascript, application/javascript, */*; q=0.01',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    }).then(function(res) {
      return Promise.all([res, res.text()]);
    }).then(function(result) {
      var res = result[0];
      var js = result[1];
      var contentType = responseContentType(res);
      if (!isJavaScriptResponse(res)) {
        var err = new Error('Expected JavaScript from ' + (res.url || requestUrl) + ' but received ' + (contentType || 'unknown content type'));
        err.status = res.status;
        err.contentType = contentType;
        err.cfRay = res.headers && res.headers.get('cf-ray');
        throw err;
      }
      var script = document.createElement('script');
      script.textContent = js;
      document.head.appendChild(script);
      document.head.removeChild(script);
    }).catch(function(error) {
      if (!error.status) {
        error.isNetworkError = true;
      }
      if (isTransientFailure(error) && job.attempt < maxAttempts) {
        queue.unshift(job);
        schedule(retryDelayMs * Math.pow(2, job.attempt - 1));
        return 'retry';
      }
      if (isBlockedOrAbortedScriptResponse(error, job)) {
        console.warn(error);
      } else {
        notifyWarning(job, error, queue.length, options || {});
      }
      if (options && typeof options.onFailure === 'function') {
        options.onFailure(job, error, api);
      }
      delete activeKeys[job.key];
      if (job.resolve) job.resolve('failed');
      return 'failed';
    });
  }

  function drain() {
    if (running) return;
    timer = null;
    var job = queue.shift();
    if (!job) return;

    running = true;
    var drainResult;
    execute(job).then(function(result) {
      drainResult = result;
      if (result !== 'retry' && activeKeys[job.key]) {
        delete activeKeys[job.key];
      }
      if (result !== 'retry' && job.resolve) job.resolve(result || 'done');
    }).finally(function() {
      running = false;
      if (queue.length > 0 && drainResult !== 'retry') schedule(0);
    });
  }

  function enqueue(url, params, enqueueOptions) {
    params = params || {};
    enqueueOptions = enqueueOptions || {};
    var key = enqueueOptions.key || keyFor(url, params);
    if (activeKeys[key] && !enqueueOptions.force) {
      return activeKeys[key];
    }

    var job = {
      key: key,
      url: url,
      endpoint: (function() {
        try {
          return new URL(url, window.location.origin).pathname;
        } catch (_error) {
          return url;
        }
      })(),
      params: params,
      options: enqueueOptions,
      domId: enqueueOptions.domId || params.domId,
      deckId: enqueueOptions.deckId || params.deckId || params.id,
      failureTarget: enqueueOptions.failureTarget || null,
      attempt: 0
    };

    var promise = new Promise(function(resolve) {
      job.resolve = resolve;
    });
    activeKeys[key] = promise;

    if (enqueueOptions.priority === 'high') {
      queue.unshift(job);
    } else {
      queue.push(job);
    }
    schedule(0);
    return promise;
  }

  var api = {
    enqueue: enqueue,
    depth: function() { return queue.length + (running ? 1 : 0); },
    _clear: function() {
      queue = [];
      activeKeys = {};
      running = false;
      if (timer) clearTimeoutImpl(timer);
      timer = null;
    }
  };
  return api;
}

function createDeckWidgetQueue(options) {
  return createScriptRequestQueue(Object.assign({
    metadataNamespace: 'deckWidgetQueue',
    metadataForJob: deckWidgetMetadata,
    onFailure: renderDeckFailure
  }, options || {}));
}

export {
  appendParams,
  createDeckWidgetQueue,
  createScriptRequestQueue,
  isBlockedOrAbortedScriptResponse,
  isTransientFailure,
  sanitizeUrl,
  stableHash
};
